import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { setUser } from "@/observability/sentry";
import { setTrackingId } from "@/tracking/trackingIds";
import type { ProfileType } from "@/types/AuthTypes";

/**
 * Tells the trackers who is signed in: the backend through `_tid`, PostHog
 * and Sentry directly. The user is known by their account's tracking id,
 * which can differ from the one `_tid` held before they signed in. PostHog
 * merges their anonymous visit, on www and the dashboard, into the account.
 */
export default function useSignedInUser(profile?: ProfileType) {
  const posthog = usePostHog();
  const trackingId = profile?.tracking_id;
  const email = profile?.email;

  useEffect(() => {
    setUser(email ? { email } : null);
  }, [email]);

  useEffect(() => {
    if (!trackingId) return;
    setTrackingId(trackingId);
    posthog?.identify(trackingId);
  }, [trackingId, posthog]);
}
